export enum StartupModalPriorities {
  baleChannelPromotion = 10,
  forceInstallTwa = 6,
  clockMismatch = 5,
  changeLog = 4,
  grantContactPermission = 3,
  grantNotificationPermission = 3,
  updateTwaAvailable = 2,
  nonTwaNotificationPermission = 2,
  outOfDateBrowser = 1,
  outOfDateOs = 1,
}
